import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { concat, of } from 'rxjs';
import { catchError, concatMap, filter, map, withLatestFrom } from 'rxjs/operators';
import { DictionaryService } from '../../services/dictionary.service';
import { loadProvinces, loadProvincesFailure, loadProvincesSuccess, toggleProvincesLoading } from './provinces.actions';
import { selectProvincesList, selectProvincesLoading } from './provinces.selectors';
import { IProvincesState } from './provinces.state';

@Injectable()
export class ProvincesEffects {
  private actions$ = inject(Actions);
  private dictionaryService = inject(DictionaryService);
  private store = inject<Store<IProvincesState>>(Store);

  constructor() {}

  loadProvinces$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadProvinces),
      withLatestFrom(this.store.select(selectProvincesList), this.store.select(selectProvincesLoading)),
      filter(([action, list, isLoading]) => !isLoading && (!list || list.length === 0)),
      concatMap(([{ countryId }]) =>
        concat(
          of(toggleProvincesLoading({ isLoading: true })),
          this.dictionaryService.provincesByCountry$(countryId).pipe(
            map((provinces) => loadProvincesSuccess({ provinces })),
            catchError((error) => of(loadProvincesFailure({ error }))),
          ),
        ),
      ),
    ),
  );
}
